<template>
  <div class="gwnl-dept-cell">
    <!-- <yxt-tooltip
      effect="light"
      :content="deptName"
      placement="top"
      :disabled="deptName === ''"
    >
      <span class="ellipsis">
        {{ deptName | deptNameFormatter | emptyFormatter }}
      </span>
    </yxt-tooltip> -->
    <yxt-popover
      effect="dark"
      trigger="hover"
      placement="top"
      :disabled="deptName === '' || deptName === null"
      show-scroll
      max-width="300"
      max-height="200"
      :open-filter="true"
    >
      <div
        slot="reference"
        class="ellipsis gwnl-dept-cell__label"
      >
        <yxtbiz-dept-name
          :class="deptName === '' || deptName === null || deptName === undefined ? 'color-gray-6' : ''"
          :name="deptName | deptNameFormatter | emptyFormatter"
        />
      </div>
      <yxtbiz-dept-name
        :class="deptName === '' || deptName === null || deptName === undefined ? 'color-gray-6' : ''"
        :name="deptName"
      />
    </yxt-popover>
  </div>
</template>
<script>
export default {
  components: {},
  filters: {
    deptNameFormatter(v) {
      let deptNameArr = v ? v.split('->') : [];
      return deptNameArr[deptNameArr.length - 1] || '';
    },
    emptyFormatter(v) {
      return v === '' || v === null || v === undefined ? '--' : v;
    }
  },
  props: {
    deptName: String
  },
  data() {
    return {};
  },
  created() {},
  methods: {}
};
</script>
<style lang="scss" scoped>
.gwnl-dept-cell {
  width: 100%;
}

.gwnl-dept-cell__label {
  // display: inline-block;
  max-width: 100%;
}
</style>
